module.exports = __webpack_public_path__ + "static/media/athlete_skeleton.11f29d05.png";